import DefaultConfigStore, { ConfigStore } from "config/store/ConfigStore";
import DefaultAuthorizationStore, { AuthorizationStore } from "./store/AuthorizationStore";

export class RefreshAuthMethodProvider {
    constructor(authorizationStore: AuthorizationStore, configStore: ConfigStore) {
        this.authorizationStore = authorizationStore;
        this.configStore = configStore;
    }

    private authorizationStore: AuthorizationStore;
    private configStore: ConfigStore;

    AuthorizeRefreshMethod(): Promise<void> {
        if (this.configStore.config?.production || process.env.REACT_APP_USE_LOCAL_TEAMS === "true") {
            return this.authorizationStore.authorize(false, true);
        }
        return Promise.resolve();
    }
}

export default new RefreshAuthMethodProvider(DefaultAuthorizationStore, DefaultConfigStore);
